export const WEB_HOSTING_FLOW = 'shared_hosting'
export const CUSTOM_HOSTING_FLOW = 'custom_hosting'
export const EMAIL_HOSTING_FLOW = 'email_hosting'
export const VPS_FLOW = 'vps'
export const SSL_FLOW = 'ssl'
export const GSUITE_FLOW = 'gsuite'
